import { cn } from "@/core/utils";
import { Clock } from "lucide-react";
import type { NoticeBlock, NoticeTone } from "../schemas/blocks";

/**
 * Renderer do block `notice`: cartão de aviso/callout curto (ex.: prazo de
 * atendimento de um chamado), colorido pelo `tone`. O front só traduz o tone
 * em cor — a decisão do tom vem do backend.
 */

function toneClass(tone: NoticeTone): string {
  switch (tone) {
    case "success":
      return "bg-success-50 border-success-200 text-success-700";
    case "warning":
      return "bg-warning-50 border-warning-200 text-warning-700";
    case "danger":
      return "bg-danger-50 border-danger-200 text-danger-700";
    case "neutral":
      return "bg-lightgray-100 border-lightgray-300 text-darkgray-700";
    default: // info
      return "bg-primary-50 border-primary-200 text-primary-700";
  }
}

export function NoticeCard({ block }: { block: NoticeBlock }) {
  if (!block.text?.trim()) return null;
  return (
    <div
      className={cn(
        "flex items-start gap-2 rounded-xl border p-3 text-sm",
        toneClass(block.tone),
      )}
    >
      <Clock className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="flex flex-col gap-0.5">
        {block.title && <span className="font-semibold">{block.title}</span>}
        <span className="leading-snug">{block.text}</span>
      </div>
    </div>
  );
}
